const TRANSFER_KEY = 'kishmat:game-notebook-transfer:v1';
const MAX_AGE_MS = 30 * 60 * 1000;

export function saveNotebookTransfer(payload) {
  const envelope = {
    createdAt: Date.now(),
    payload
  };
  sessionStorage.setItem(TRANSFER_KEY, JSON.stringify(envelope));
}

export function takeNotebookTransfer(expectedKind) {
  const raw = sessionStorage.getItem(TRANSFER_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(TRANSFER_KEY);
  try {
    const envelope = JSON.parse(raw);
    if (!envelope?.payload || Date.now() - Number(envelope.createdAt || 0) > MAX_AGE_MS) return null;
    if (expectedKind && envelope.payload.kind !== expectedKind) return null;
    return envelope.payload;
  } catch {
    return null;
  }
}

